import type { ReactNode } from 'react';

import { Box, Typography } from '@mui/material';

type HintProps = {
  children: ReactNode;
};

export const Hint = (props: HintProps) => {
  const { children } = props;

  return (
    <Box display="flex" justifyContent="center" py={4} px={2}>
      <Typography variant="body2" color="text.secondary" textAlign="center">
        {children}
      </Typography>
    </Box>
  );
};
